import { useEffect } from 'react';
import { Button, Modal, Input, Form, Space, Typography } from 'antd';
import { toast } from 'sonner';
import { CometChatUIKit, getLocalizedString } from '@cometchat/chat-uikit-react';
import { CometChat } from "@cometchat/chat-sdk-javascript";

const { Title, Text } = Typography;

// 定义组件属性接口
interface EditProfileModalProps {
  open: boolean;
  onClose: () => void;
  uid: string;
  // 可选：初始表单数据
  initialValues?: {
    name: string;
  };
  // 可选：表单提交回调
  onSubmit?: (values: { name: string }) => void;
}

export function EditProfileModal({
  open,
  onClose,
  uid,
  initialValues = { name: 'Pedro Duarte' },
  onSubmit,
}: EditProfileModalProps) {
  // Form 实例
  const [form] = Form.useForm<{ name: string }>();

  // 当初始化时，更新表单数据
  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, []);

  // 提交表单
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      console.log('表单提交数据:', values);
      if (onSubmit) {
        await onSubmit(values);
      } else {
        const user = new CometChat.User(uid);
        user.setName(values.name);
        // await CometChatUIKit.updateUser(user);
        // @FIXME: 更新历史数据
        await CometChat.updateCurrentUserDetails(user)
      }
      toast.success(getLocalizedString('edit_profile_successfully'));
      onClose();
    } catch (error: any) {
      console.log('表单验证失败:', error);
    }
  };

  return (
    <Modal
      title={
        <>
          <Title level={4} style={{ margin: 0 }}>
            { getLocalizedString('edit_profile') }
          </Title>
          <Text type="secondary">
            { getLocalizedString('edit_profile_desc') }
          </Text>
        </>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Space key="modal-footer">
          <Button onClick={onClose} ghost>
            { getLocalizedString('cancel') }
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            { getLocalizedString('save_changes') }
          </Button>
        </Space>,
      ]}
      width={425}
    >
      <Form
        form={form}
        layout="vertical"
        name="edit_profile_form"
        style={{ marginTop: 16 }}
      >
        <Form.Item
          name="name"
          label={ getLocalizedString('edit_profile_name') }
          rules={[{ required: true, message: getLocalizedString('edit_profile_name_error') }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditProfileModal;
